import { BACKGROUND_FILL_TYPE, IHasBackground, ILandingSection } from "../../../data/interfaces"
import BackgroundFolds from "./background/BackgroundFolds"
import BackgroundHexagonalMesh from "./background/BackgroundHexagonalMesh"
import {
    BackgroundBokeh,
    BackgroundHologram,
    BackgroundMademoiselle,
    BackgroundPlain,
    BackgroundRoads,
    BackgroundSmart,
} from "./background/index"


/* Protopia Ecosystem component */
export interface IBackgroundProps {
   section: IHasBackground | ILandingSection
}
const Background = ({section, ...props}: IBackgroundProps): JSX.Element => {
    const fillType = !!( section.smart_background|| section.background )?.fillType 
        ? 
        ( section.smart_background|| section.background ).fillType 
        : 
        BACKGROUND_FILL_TYPE.NONE 
    
    switch(fillType) {
        case BACKGROUND_FILL_TYPE.ROADS:
            return <BackgroundRoads section={section} />
        case BACKGROUND_FILL_TYPE.HOLOGRAM:
            return <BackgroundHologram section={section} />
        case BACKGROUND_FILL_TYPE.SMART:
        case BACKGROUND_FILL_TYPE.NOISE:
            return <BackgroundSmart section={section}/>
        case BACKGROUND_FILL_TYPE.MADEMOISELLE:
            return <BackgroundMademoiselle section={section}/>
        case BACKGROUND_FILL_TYPE.BOKE:
            return <BackgroundBokeh section={section}/>
        case BACKGROUND_FILL_TYPE.HEXAGONS:
            return <BackgroundHexagonalMesh section={section}/>
        case BACKGROUND_FILL_TYPE.FOLDS:
            return <BackgroundFolds section={section}/>
        case BACKGROUND_FILL_TYPE.PLAIN:
        case BACKGROUND_FILL_TYPE.NONE:
        default: 
            return <BackgroundPlain section={section} />
    }
}
export default Background